export const USER_LIST = "users/USER_LIST";
export const USER_CREATE = "users/USER_CREATE";
export const USER_DELETE = "users/USER_DELETE";
export const USER_EDIT = "users/USER_EDIT";
export const USER_DETAILS = "users/USER_DETAILS";